class DsProductDesktopDetails extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.root = this.closest('.main-product[product-info]');
    this.details = this.root?.querySelector('[product-details]');
    if (!this.details) return;
    this.records = new Map();
    this.media = window.matchMedia('(min-width: 992px)');
    this.controller = new AbortController();
    this.refresh = this.refresh.bind(this);
    this.media.addEventListener('change', this.refresh, { signal: this.controller.signal });
    this.observer = new MutationObserver(this.refresh);
    this.refresh();
  }

  blockFor(node) {
    while (node.parentElement && node.parentElement !== this.details && node.parentElement !== this) {
      node = node.parentElement;
    }
    return node.parentElement === this.details || node.parentElement === this ? node : null;
  }

  refresh() {
    this.observer.disconnect();
    this.details = this.root.querySelector('[product-details]');
    if (!this.details) {
      this.observer.observe(this.root, { childList: true, subtree: true });
      return;
    }
    for (const [node, anchor] of this.records) {
      if (!node.isConnected || !anchor.isConnected) {
        if (!anchor.isConnected && this.contains(node)) node.remove();
        anchor.remove();
        this.records.delete(node);
      }
    }
    const groups = [
      [...this.root.querySelectorAll('.pu-ptb')],
      [...this.details.querySelectorAll(':scope > .RTE-content')],
      [...this.root.querySelectorAll('.ds-aroma-help')].map(node => this.blockFor(node)),
      [...this.root.querySelectorAll('.ds-delivery')].map(node => this.blockFor(node)),
      [...this.root.querySelectorAll('accordion-tab')].filter(node => !node.closest('.pu-ptb')).map(node => this.blockFor(node)),
      [...this.root.querySelectorAll('.product__form-share')].map(node => this.blockFor(node))
    ];
    const ordered = [...new Set(groups.flat().filter(Boolean))];
    for (const node of ordered) {
      if (!this.records.has(node)) {
        const anchor = document.createElement('template');
        anchor.setAttribute('data-ds-details-origin', '');
        node.before(anchor);
        this.records.set(node, anchor);
      }
    }
    if (this.media.matches) {
      ordered.forEach((node, index) => {
        const before = this.children[index] || null;
        if (before === node) return;
        if (this.moveBefore && node.isConnected) this.moveBefore(node, before);
        else this.insertBefore(node, before);
      });
    } else {
      for (const [node, anchor] of this.records) {
        if (anchor.nextSibling !== node) anchor.after(node);
      }
    }
    this.observer.observe(this.root, { childList: true, subtree: true });
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
    this.controller = null;
  }
}

if (!customElements.get('ds-product-desktop-details')) {
  customElements.define('ds-product-desktop-details', DsProductDesktopDetails);
}
